<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white pl-3">
                Dashboard </router-link>
            <router-link to="/admin/eduschool/eduschool-exam-prep" class="text-white pl-3">
                <span class="text-white"><i class="fa fa-ellipsis-v"></i> Exam Prep Exam</span> </router-link>
            <span class="text-white pl-3"><i class="fa fa-ellipsis-v"></i> Exam Prep Exam Subject</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div class="row">
                    <div class=" col-md-3">
                        <div class="card border-0 mb-0">
                            <div class="card-header">
                                Register Here
                            </div>
                            <div class="card-body">
                                <div class="form-horizontal">
                                    <form role="form" @submit.prevent="submitdata">
                                        <div class="form-group">
                                            <input v-model="ExamSubjectval" class="form-control"
                                                placeholder="Enter Subject Name">
                                        </div>
                                        <div class="text-center">
                                            <button type="submit" class="btn btn-success"> Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" col-md-9">
                        <div class="form-inline">
                            <div class="input-group">
                                <input v-model="searchval" class="form-control" @keyup="getsearch"
                                    placeholder="Search...">
                                <div class=" input-group-append">
                                    <button type="button" @click.prevent="getsearch" class="btn btn-secondary"><i
                                            class="fa fa-search"></i> Search </button>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <transition name="fade">
                                <list-skeleton v-if="!subjectitems" :rows="3" />
                            </transition>
                            <div class="row">
                                <div class="col" v-for="item in subjectitems" :key="item.Id">
                                    <div class="card m-2 animate__animated animate__backInUp">
                                        <div class="card-body bg-secondary text-center">
                                            <h5>{{ item.examSubject }}</h5>
                                            <div class="card-footer">
                                                <button class="btn btn-secondary btn-sm"
                                                    v-on:click="GetExamSubjectById(item)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                                <button class="btn btn-default btn-sm"
                                                    v-on:click="openquestion(item.examSubjectId)">
                                                    <i class="fa fa-list"></i> Questions
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>

    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
export default {
    name: 'ExamPrepSubject',
    mixins: [Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            ExamIdval: localStorage.getItem('ExamId') || '',
            ExamSubjectIdval: 0,
            ExamSubjectval: '',
            searchval: '',
            subjectitems: '',
            isModified: false,
            onloader: 'none'
        }
    },
    methods: {
        resetInput() {
            this.ExamSubjectval = "";
            this.isModified = false;
        },
        openquestion(examSubjectId) {
            localStorage.setItem('ExamSubjectId', examSubjectId);
            this.$router.push('/admin/eduschool/eduschool-exam-prep/subject/questions');
        },
        GetExamSubjectById(item) {
            this.ExamSubjectIdval = item.examSubjectId;
            this.ExamSubjectval = item.examSubject;
            this.isModified = true;
            this.onloader = 'none';
        },
        submitdata() {
            let ExamSubjectId = this.ExamSubjectIdval;
            let ExamId = this.ExamIdval;
            let ExamSubject = this.ExamSubjectval;
            this.onloader = 'flex';
            let userdata = {};
            let operationVal = "";
            if (this.isModified == false) {
                operationVal = "ExamPrep/CreateExamSubject";
                userdata = {
                    ExamId,
                    ExamSubject
                }
            } else {
                operationVal = "ExamPrep/UpdateExamSubject";
                userdata = {
                    ExamSubjectId,
                    ExamId,
                    ExamSubject
                }
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == '00') {
                        this.GetExamSubjects();
                        this.resetInput();
                        this.ShowAlertSuccess('Submitted successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetExamSubjects() {
            this.onloader = 'flex'
            let ExamId = this.ExamIdval;
            this.$store.dispatch('ExamPrep/GetExamSubjects', ExamId)
                .then((resp) => {
                    this.subjectitems = resp.data;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getsearch() {

            let Id = this.ExamIdval;
            let item = this.searchval;
            let userdata = {
                Id,
                item
            }
            this.$store.dispatch('GetExamSubjectssearch', userdata)
                .then((resp) => {
                    this.subjectitems = resp;

                })
                .catch(err => {
                    this.ShowAlertError(err.response.data, '');

                })
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetExamSubjects();
        } else {

            this.$store.dispatch('logout')
            this.$router.push('/login')
        }

    }
};
</script>

<style></style>
